import React from 'react';
import { sanitizeHtml } from '../../../utils/sanitizeHtml';

const GoruntulemeAlani = ({ sablon }) => (
  <div className="scrollbar-slim flex flex-col overflow-auto rounded-xl border border-slate-200 bg-slate-100 p-4">
    <div className="mx-auto w-full max-w-[21cm] min-h-[29.7cm] bg-white p-[1cm] shadow-lg">
      <div className="prose max-w-none">
        <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(sablon.icerik) }} />
      </div>
    </div>
  </div>
);

export default GoruntulemeAlani;
